import View from '../../view.js';

namespace('IO.Views.Components', function (exports) {
  'use strict';

  var SimpleField = View.extend({
    dom: {
      MULTIPLE_VALUE_PROPERTY: '.multiple-value-property',
      MULTIPLE_VALUE_PROPERTY_BUTTON_ADD: '.multiple-value-button-add',
      MULTIPLE_VALUE_PROPERTY_BUTTON_REMOVE: '.multiple-value-button-remove',
      SELECT2_NOT_INITIALIZED: '.select2select:not(.select2-container)',
      SIMPLE_MULTIPLE_VALUE_TEMPLATE_PREFIX:
        '#simple-multiple-value-attribute-template-',
      SIMPLE_MULTIPLE_VALUE_ENTRY: '.simple-multiple-value-attribute-entry',
      SIMPLE_MULTIPLE_VALUE_PROPERTY_BUTTON_ADD: '.multiple-value-button-add',
      SIMPLE_MULTIPLE_VALUE_PROPERTY_BUTTON_REMOVE:
        '.multiple-value-button-remove',
    },

    events: function () {
      var events = {};

      if (this.options.multiple) {
        events['click ' + this.dom.SIMPLE_MULTIPLE_VALUE_PROPERTY_BUTTON_ADD] =
          '_appendNewField';
        events[
          'click ' + this.dom.SIMPLE_MULTIPLE_VALUE_PROPERTY_BUTTON_REMOVE
        ] = '_removeMultipleField';
      }
      return events;
    },

    initialize: function (options) {
      if (options.limited && !options.multiple) {
        throw new Error(
          'Ip Field: You cannot initialize defining "limited" without "multiple: true"',
        );
      }
    },

    destroy: function () {
      this.off();
      this.remove();
    },

    isValid: function () {
      return true;
    },

    _appendNewField: function (e) {
      var $target = $(e.currentTarget),
        $property = $target.closest(this.dom.MULTIPLE_VALUE_PROPERTY),
        numberInputs;

      this._appendTemplate($property);

      numberInputs = $property.find(
        this.dom.SIMPLE_MULTIPLE_VALUE_ENTRY,
      ).length;
      if (
        this.options.limited &&
        this._isLimited($target.data('input')) &&
        this._reachedLimit($target.data('input'), numberInputs)
      ) {
        $target.hide();
        $property
          .find(this.dom.MULTIPLE_VALUE_PROPERTY_BUTTON_REMOVE)
          .last()
          .show();
      }

      return false;
    },

    _appendTemplate: function ($property) {
      var counter = $property.data('counter'),
        vname = $property.data('vname'),
        tmpl = _.template(
          this.$(
            this.dom.SIMPLE_MULTIPLE_VALUE_TEMPLATE_PREFIX + counter,
          ).text(),
        )({ vname: vname });

      $property.append(tmpl);
      $property.find(this.dom.SELECT2_NOT_INITIALIZED).select2(
        select2Defaults({
          acceptNotFound: true,
          allowClear: true,
          placeholder: 'None',
        }),
      );
    },

    _removeMultipleField: function (e) {
      var $target = $(e.currentTarget),
        $multipleProperty = $target.closest(this.dom.MULTIPLE_VALUE_PROPERTY),
        numberInputs = $multipleProperty.find(
          this.dom.SIMPLE_MULTIPLE_VALUE_ENTRY,
        ).length;

      if (
        this.options.limited &&
        this._isLimited($target.data('input')) &&
        this._reachedLimit($target.data('input'), numberInputs)
      ) {
        $multipleProperty
          .find(this.dom.MULTIPLE_VALUE_PROPERTY_BUTTON_ADD)
          .show();
      }

      $target.closest('div').remove();
      return false;
    },

    _isLimited: function (input) {
      return _.contains(_.keys(this.options.limited), input);
    },

    _reachedLimit: function (input, number) {
      return number === this.options.limited[input];
    },
  });

  exports.SimpleField = SimpleField;
});
